var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.spinner_i)?_c('b-spinner',{attrs:{"variant":"success"}}):_c('i',{staticClass:"btn-edit fa fa-check",staticStyle:{"cursor":"pointer"},attrs:{"title":"Pedido separado."},on:{"click":function($event){return _vm.proximoStatus()}}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c41cba4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Expeditions_v2/Aggregates/Support/ConfirmarSeparacao.vue
// module id = VELo
// module chunks = 0